import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { ar } from '../translations/ar';
import { en } from '../translations/en';

const LanguageContext = createContext();

const translations = { ar, en };

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('namaa_language');
    return saved || 'ar';
  });

  const isRTL = language === 'ar';

  useEffect(() => {
    localStorage.setItem('namaa_language', language);
    // Layout stays RTL always (Saudi app), only text language changes
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = language;
    
    // Keep Arabic font for layout consistency
    document.body.style.fontFamily = "'Cairo', 'IBM Plex Sans', sans-serif";
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'ar' ? 'en' : 'ar');
  }, []);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return value;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, isRTL, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
